import styled from 'styled-components';

import JobReviewListItem from './component';

import { listItemStyles } from 'modules/fleet/list';

export default styled(JobReviewListItem)`
  ${listItemStyles}

  &.selected {
    &,
    &:hover {
      background-color: var(--grey800);
      color: #fff;
      .cell {
        background-color: var(--grey800);
      }
      .cell__dark {
        background-color: var(--grey800);
      }
    }
  }
`;
